import { appRoutes } from "../../../constants/appRoutes";

export const articleRoute = {
    path: appRoutes.articles.path,
    lazy: () => import('../../../pages/Articles'),
}